import { Box, Flex } from 'vvs-uikit'
import { HealthCareFlex } from './styles'

const HealthCareColumn: React.FC<{ title: React.ReactElement }> = ({ title, children }) => (
  <Box>
    <HealthCareFlex>
      <Flex alignItems="center">{title}</Flex>

      {children}
    </HealthCareFlex>
  </Box>
)

export default HealthCareColumn
